import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorVip = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M7.5 2.875 8.786 6.5h6.428L16.5 2.875l-2.893.938L12 1l-1.607 2.813L7.5 2.875Zm1.65 10.366a1 1 0 1 0-1.3 1.518l2.848 2.442a2 2 0 0 0 2.604 0l2.849-2.442a1 1 0 0 0-1.302-1.518L12 15.683 9.15 13.24Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M4.762 7.204a2.25 2.25 0 0 1 1.84-.954h10.796a2.25 2.25 0 0 1 1.84.954l3.084 4.377a2.25 2.25 0 0 1-.388 3.015l-8.483 7.16a2.25 2.25 0 0 1-2.902 0l-8.482-7.16a2.25 2.25 0 0 1-.388-3.015l3.083-4.377Zm1.84.546a.75.75 0 0 0-.613.318l-3.084 4.377a.75.75 0 0 0 .13 1.005l8.481 7.16a.75.75 0 0 0 .968 0l8.482-7.16a.75.75 0 0 0 .13-1.005l-3.084-4.377a.75.75 0 0 0-.614-.318H6.602Z"
    />
  </svg>
);
export default SvgTwoColorVip;
